import { render, staticRenderFns } from "./ClientPortalGeneralSettings.vue?vue&type=template&id=9ba03652&scoped=true"
import script from "./ClientPortalGeneralSettings.vue?vue&type=script&lang=ts"
export * from "./ClientPortalGeneralSettings.vue?vue&type=script&lang=ts"
import style0 from "./ClientPortalGeneralSettings.vue?vue&type=style&index=0&id=9ba03652&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba03652",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba03652')) {
      api.createRecord('9ba03652', component.options)
    } else {
      api.reload('9ba03652', component.options)
    }
    module.hot.accept("./ClientPortalGeneralSettings.vue?vue&type=template&id=9ba03652&scoped=true", function () {
      api.rerender('9ba03652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/ClientPortalGeneralSettings.vue"
export default component.exports